import { render, staticRenderFns } from "./messageBilling.vue?vue&type=template&id=36959c0e&scoped=true&"
import script from "./messageBilling.vue?vue&type=script&lang=js&"
export * from "./messageBilling.vue?vue&type=script&lang=js&"
import style0 from "./messageBilling.vue?vue&type=style&index=0&id=36959c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36959c0e",
  null
  
)

export default component.exports